import { ChevronDown, ExternalLink, Unplug } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { anunciosMetaApi, dataHoraBR, mensagemDeErro, urlGerenciador } from "./api";

/**
 * O que quase nunca muda, recolhido no fim da tela: o imposto que a Meta soma
 * ao gasto, os ids da conexão e o botão de desfazer.
 */
function Dado({ rotulo, children }) {
  return (
    <div className="min-w-0">
      <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{rotulo}</p>
      <p className="text-sm truncate">{children}</p>
    </div>
  );
}

export default function Ajustes({ conexao, podeGerir, podeDesfazer, onMudou }) {
  const salvo = String(conexao?.imposto_pct ?? 13.83);
  const [imposto, setImposto] = useState(salvo);

  const salvarImposto = async () => {
    if (imposto === salvo) return;
    try { await anunciosMetaApi.salvarImposto(Number(String(imposto).replace(",", "."))); toast.success("Imposto atualizado."); onMudou(); }
    catch (e) { toast.error(mensagemDeErro(e, "Valor inválido.")); setImposto(salvo); }
  };
  const desfazer = async () => {
    if (!window.confirm("Desfazer a conexão com a Meta? O histórico de gasto fica guardado.")) return;
    try { await anunciosMetaApi.desconectar(); toast.success("Conexão desfeita."); onMudou(); }
    catch (e) { toast.error(mensagemDeErro(e, "Não foi possível desfazer.")); }
  };

  return (
    <details className="group rounded-xl border bg-card" data-e2e="meta-ajustes">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-2 p-4 sm:px-5 font-semibold [&::-webkit-details-marker]:hidden">
        Ajustes da conexão
        <ChevronDown className="w-4 h-4 text-muted-foreground transition-transform group-open:rotate-180" />
      </summary>
      <div className="border-t p-4 sm:p-5 space-y-4">
        <div className="grid gap-4 sm:grid-cols-3">
          <Dado rotulo="Conta de anúncio">{conexao.ad_account_nome} <span className="text-xs text-muted-foreground">({conexao.ad_account_id})</span></Dado>
          <Dado rotulo="Portfólio da loja">{conexao.business_nome || "—"} <span className="text-xs text-muted-foreground">({conexao.business_id})</span></Dado>
          <Dado rotulo="Conectada em">{dataHoraBR(conexao.conectada_em)}</Dado>
        </div>
        {podeGerir && (
          <label className="flex flex-wrap items-center gap-2 text-sm">
            Imposto que a Meta soma ao gasto
            <input value={imposto} onChange={(e) => setImposto(e.target.value)} onBlur={salvarImposto} inputMode="decimal" data-e2e="meta-imposto"
              className="w-20 rounded-lg border bg-background px-2 py-1 text-sm text-right tabular-nums" /> %
            <span className="text-xs text-muted-foreground">padrão 13,83% (PIS/Cofins e ISS repassados desde 2026). O "investido" da tela já inclui.</span>
          </label>
        )}
        <div className="flex flex-wrap items-center gap-2">
          <a href={urlGerenciador(conexao)} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm hover:border-primary">
            <ExternalLink className="w-3.5 h-3.5" /> Abrir o Gerenciador de Anúncios
          </a>
          {podeDesfazer && (
            <button onClick={desfazer} data-e2e="meta-desfazer"
              className="inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm text-muted-foreground hover:text-destructive hover:border-destructive">
              <Unplug className="w-3.5 h-3.5" /> Desfazer conexão
            </button>
          )}
        </div>
      </div>
    </details>
  );
}
